<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="search">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="问题类型">
              <a-select
                v-model="queryParam.typeId"
                show-search
                allowClear
                placeholder="请选择产品"
              >
                <a-select-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.type }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="关键词">
              <a-input
                placeholder="请输入关键词"
                v-model="queryParam.keyWord"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否启用">
              <a-select
                v-model="queryParam.status"
                placeholder="请选择是否启用"
                allowClear
              >
                <a-select-option :value="'0'"> 是 </a-select-option>
                <a-select-option :value="'1'"> 否 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="search" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchResetForm"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd()" type="primary" icon="plus"
        >新增关键词</a-button
      >
      <a-button @click="handleCommonProblemSet()" type="primary"
        >问题类型管理</a-button
      >
      <a-button @click="batchDel" type="primary" icon="delete"
        >批量操作</a-button
      >
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch
            v-model="record.statusBl"
            checked-children="启用"
            un-checked-children="禁用"
            @click="handleShelveCommon(record)"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <commonProblem-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></commonProblem-modal>

    <!--  问题类型管理-->
    <a-modal
      title="问题类型管理"
      @cancel="commonProblemSetCancel()"
      :visible="commonProblemSetVisible"
      :footer="null"
      width="800px"
    >
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="commonProblemSetEdit()" type="primary"
          >新增类型</a-button
        >
        <a-dropdown v-if="commonProblemSetListSelections.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="commonProblemSetBatchDel"
              ><a-icon type="delete" />删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down"
          /></a-button>
        </a-dropdown>
      </div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :loading="commonProblemSetLoading"
        :dataSource="commonProblemSetList"
        :columns="commonProblemSetColumns"
        :pagination="commonProblemSetPagination"
        :row-selection="{
          selectedRowKeys: commonProblemSetListSelections,
          onChange: commonProblemSetOnSelectChange,
        }"
        @change="commonProblemSetTableChange"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch
            v-model="record.statusBl"
            checked-children="启用"
            un-checked-children="禁用"
            @click="handleShelve(record)"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="commonProblemSetEdit(record)">编辑</a>&nbsp;
          <a @click="commonProblemSetBatchDel(record.id)">删除</a>
        </span>
      </a-table>
    </a-modal>

    <!-- 问题类型管理添加编辑 -->
    <a-modal
      :title="this.commonProblemModel.id ? '修改类型' : '新增类型'"
      :visible="commonProblemSetEditVisible"
      @cancel="commonProblemSetEditCancel"
      @ok="commonProblemSetEditOk"
    >
      <a-form :form="commonProblemSetForm">
        <a-form-item
          label="类型名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['type', validatorRules.type]"
            placeholder="请输入类型名称"
          ></a-input>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['sortIndex']" :min="0" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
// import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import CommonProblemModal from './modules/CommonProblemModal';
import JDate from '@/components/jeecg/JDate.vue';
import { validateDuplicateValue } from '@/utils/util';
import { getAction, postAction, postTag } from '../../../api/manage';
// import moment from 'moment';
import pick from 'lodash.pick';

export default {
  name: 'CommonProblemList',
  mixins: [JeecgListMixin],
  components: {
    JDate,
    CommonProblemModal,
  },
  data() {
    return {
      title: '',
      commonProblemSetEditVisible: false,
      commonProblemSetVisible: false,
      commonProblemSetLoading: false,
      confirmLoading: false,
      commonProblemSetList: [],
      commonProblemSetForm: this.$form.createForm(this),
      commonProblemModel: {},
      commonProblemSetListSelections: [],
      typeList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      commonProblemSetPage: 1,
      commonProblemSetPageSize: 2,
      commonProblemSetPagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
      },
      // 表头
      columns: [
        {
          title: '问题类型',
          align: 'center',
          dataIndex: 'type',
        },
        {
          title: '关键词',
          align: 'center',
          dataIndex: 'keyWord',
        },
        {
          title: '跳转链接',
          align: 'center',
          dataIndex: 'jumpUrl',
        },
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sortIndex',
          sorter: (a, b) => a.sortIndex - b.sortIndex,
        },
        {
          ellipsis: true,
          title: '是否启用',
          align: 'center',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '点击量',
          align: 'center',
          dataIndex: 'clickTime',
          sorter: (a, b) => a.clickTime - b.clickTime,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      commonProblemSetColumns: [
        {
          title: '类型',
          align: 'center',
          dataIndex: 'type',
        },
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sortIndex',
          sorter: (a, b) => a.sortIndex - b.sortIndex,
        },
        {
          ellipsis: true,
          title: '是否启用',
          align: 'center',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      validatorRules: {
        type: {
          rules: [
            { required: true, message: '请输入类型名称!' },
            {
              validator: (rule, value, callback) =>
                validateDuplicateValue(
                  'CONT_COMMON_PROBLEM_SET',
                  'TYPE',
                  value,
                  this.commonProblemModel.id,
                  callback
                ),
            },
          ],
        },
      },
      url: {
        delete: process.env.VUE_APP_CMS_CONTENT + '/ct/problem/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/ct/problem/deleteBatch',
        add: process.env.VUE_APP_CMS_CONTENT + '/ct/problemSet/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/ct/problemSet/edit',
      },
    };
  },
  watch: {
    queryParam(val) {
      console.log('startValue', val);
    },
  },
  methods: {
    search() {
      this.searchQuery();
    },
    searchResetForm() {
      this.searchReset();
    },
    initDictConfig() {},
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      let params = this.getQueryParams(); //查询条件
      this.loading = true;
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/ct/problem/list',
        params
      ).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    //跳转回基金经理页面
    back: function () {
      this.$router.push({
        name: 'product-ProductsFundManager-ProductsFundManagerList',
      });
    },

    handleCommonProblemSet() {
      this.commonProblemSetVisible = true;
      this.commonProblemSetLoading = true;
      let params = {
        pageNo: this.commonProblemSetPage,
        pageSize: this.commonProblemSetPageSize,
      };
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/ct/problemSet/list',
        params
      ).then((res) => {
        if (res.success) {
          this.commonProblemSetList = res.result.records;
          this.commonProblemSetPagination.total = res.result.total;
          this.commonProblemSetPagination.pageSize = res.result.size;
        } else {
          this.$message.warning(res.message);
        }
        this.commonProblemSetLoading = false;
      });
    },
    commonProblemSetCancel() {
      this.commonProblemSetVisible = false;
    },
    handleShelve(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要禁用所选数据?';
      let formData = { ...record };
      let that = this;
      this.$confirm({
        title: record.statusBl ? '启用' : '禁用',
        content: record.statusBl ? strOpen : strClose,
        onOk() {
          formData.status = record.statusBl ? '0' : '1';
          that.$http
            .post(
              process.env.VUE_APP_CMS_CONTENT + '/ct/problemSet/handleShelve',
              formData,
              { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
            )
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
                record.statusBl = !record.statusBl;
              }
            })
            .finally(() => {
              that.getTypeList();
            });
        },
        onCancel() {
          record.statusBl = !record.statusBl;
        },
      });
      console.log(record);
    },
    handleShelveCommon(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要禁用所选数据?';
      let formData = { ...record };
      let that = this;
      this.$confirm({
        title: record.statusBl ? '启用' : '禁用',
        content: record.statusBl ? strOpen : strClose,
        onOk() {
          formData.status = record.statusBl ? '0' : '1';
          that.$http
            .post(
              process.env.VUE_APP_CMS_CONTENT + '/ct/problem/handleShelve',
              formData,
              { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
            )
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
                record.statusBl = !record.statusBl;
              }
            });
        },
        onCancel() {
          record.statusBl = !record.statusBl;
        },
      });
      console.log(record);
    },
    commonProblemSetOnSelectChange(selectedRowKeys) {
      this.commonProblemSetListSelections = selectedRowKeys;
      console.log(this.commonProblemSetListSelections);
    },
    commonProblemSetBatchDel(id) {
      let that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk() {
          if (that.commonProblemSetListSelections.length > 0) {
            id = that.commonProblemSetListSelections.join(',');
          }
          postAction(
            process.env.VUE_APP_CMS_CONTENT + '/ct/problemSet/deleteBatch',
            { ids: id }
          )
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.commonProblemSetListSelections = [];
              that.handleCommonProblemSet();
              that.getTypeList();
            });
        },
        onCancel() {},
      });
    },
    commonProblemSetEdit(record) {
      this.commonProblemSetEditVisible = true;
      this.commonProblemSetForm.resetFields();
      this.commonProblemModel = Object.assign({}, record);
      this.$nextTick(() => {
        setTimeout(() => {
          this.commonProblemSetForm.setFieldsValue(
            pick(this.commonProblemModel, 'type', 'sortIndex')
          );
        });
      });
    },
    commonProblemSetEditCancel() {
      this.commonProblemSetEditVisible = false;
    },
    commonProblemSetEditOk() {
      const that = this;
      this.commonProblemSetForm.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.commonProblemModel.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.commonProblemModel, values);
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.commonProblemSetEditVisible = false;
              that.handleCommonProblemSet();
              that.getTypeList();
            });
        }
      });
    },
    getTypeList() {
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/ct/problemSet/listAll'
      ).then((res) => {
        if (res.success) {
          this.typeList = res.result;
        }
      });
    },
    commonProblemSetTableChange(pagination) {
      const page = { ...this.commonProblemSetPagination };
      this.commonProblemSetPagination.current = pagination.current;
      this.commonProblemSetPagination.pageSize = pagination.pageSize;
      this.commonProblemSetPage = pagination.current;
      this.commonProblemSetPageSize = pagination.pageSize;
      this.commonProblemSetPagination = page;
      this.handleCommonProblemSet();
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record, this.typeList);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAdd: function () {
      this.$refs.modalForm.add(this.typeList);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
  },
  created() {
    if (!this.disableMixinCreated) {
      console.log(' -- mixin created -- ');
      this.loadData();
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
    }
    this.getTypeList();
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
